import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchaseNotices } from '../data/painPoints';
const MINUTES_AGO = [2, 3, 4, 6, 7, 9, 11, 13];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimeout: number;
    let hideTimeout: number;
    const cycle = () => {
      setVisible(true);
      hideTimeout = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % purchaseNotices.length);
        showTimeout = window.setTimeout(cycle, 9000);
      }, 6000);
    };
    showTimeout = window.setTimeout(cycle, 7000);
    return () => {
      window.clearTimeout(showTimeout);
      window.clearTimeout(hideTimeout);
    };
  }, [dismissed]);
  const notice = purchaseNotices[index];
  const minutes = MINUTES_AGO[index % MINUTES_AGO.length];
  return <AnimatePresence data-id="element-292" data-mp="163whj56omo8n">
      {visible && !dismissed ? <motion.div initial={{
      x: -24,
      opacity: 0,
      scale: 0.96
    }} animate={{
      x: 0,
      opacity: 1,
      scale: 1
    }} exit={{
      x: -24,
      opacity: 0,
      scale: 0.96
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-[5.75rem] left-3 z-30 w-[calc(100%-1.5rem)] max-w-[19rem] sm:bottom-24 sm:left-5" role="status" aria-live="polite" data-id="element-293" data-mp="115uyuld64qxp">
          <div className="flex items-start gap-3 rounded-2xl border border-navy-900/10 bg-white p-3 shadow-lift" data-id="element-294" data-mp="i9v08rpoqp55">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gold-100 text-gold-600" data-id="element-295" data-mp="x2y8u9latsjq">
              <ShoppingBagIcon className="h-4.5 w-4.5" aria-hidden="true" data-id="element-296" data-mp="28k7pkod1m6hc" />
            </span>

            <div className="min-w-0 flex-1" data-id="element-297" data-mp="23ld6rmf2shx8">
              <p className="truncate text-[13px] font-extrabold leading-tight text-navy-900" data-id="element-298" data-mp="23kleakgrz0b6">
                {notice.name} <span aria-hidden="true" data-id="element-299" data-mp="2ao1mavp2hlop">{notice.flag}</span>
              </p>
              <p className="mt-0.5 text-[12px] leading-snug text-navy-700/80" data-id="element-300" data-mp="2fmmqf67fwpif">
                just purchased{' '}
                <span className="font-bold text-navy-900" data-id="element-301" data-mp="2knaebj0dgq8f">Occlusion 360™</span>
              </p>
              <p className="mt-1 text-[11px] font-medium text-navy-700/55" data-id="element-302" data-mp="2pkiuxf5vgm7k">
                {notice.city}, {notice.country} · {minutes} minutes ago
              </p>
            </div>

            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="-mr-1 -mt-1 shrink-0 rounded-lg p-1 text-navy-700/40 transition-colors duration-150 ease-out hover:bg-navy-900/5 hover:text-navy-900" data-id="element-303" data-mp="1wy7zeix4hbhm">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-304" data-mp="1972jk3r6mj7b" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}